import script from "./DepositSection7.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositSection7.vue?vue&type=script&setup=true&lang=js"

import "./DepositSection7.vue?vue&type=style&index=0&id=6195474a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6195474a"]])

export default __exports__